
import React from 'react'
import { NavLink } from 'react-router'
import {Typography,
  Tooltip,
  IconButton,
  Menu,
  List, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined'
import DeleteProperties from '@/housefolios-components/Properties/DeleteProperties'
import {
  sidebarActionsBtnSx,
  sidebarNavActionsWrapSx,
  sidebarNavItemCountSx,
} from '@/layout-blueprints/chromeComponentSx'

const TrashSection = ({
  trashedProperties,
  anchorElTrashMenu,
  openTrashOptions,
  handleCloseTrashOptions,
}) => (
  <ul>
    <Box component="li" data-hf="hover-show-hide-container" sx={{
      "& [data-hf-hover=\"show\"]": { display: "none" },
      "& [data-hf-hover=\"hide\"]": { display: "block" },
      "&:hover [data-hf-hover=\"show\"]": { display: "block" },
      "&:hover [data-hf-hover=\"hide\"]": { display: "none" },
    }}>
      <NavLink
        to="/trash"
      >
        <span data-hf="sidebar-icon">
          <FontAwesomeIcon size="sm" icon={['fas', 'trash']} />
        </span>
        <span data-hf="sidebar-item-label">
          Trash
          <Box
            component="span"
            data-hf-hover="hide"
            sx={sidebarNavItemCountSx}
          >
            <Typography component="span">
              {trashedProperties.length}
            </Typography>
          </Box>
          <Box
            component="span"
            data-hf-grid="keep"
            data-hf-hover="show"
            sx={sidebarNavActionsWrapSx}
          >
            <Tooltip
              title="Trash Options"
              slotProps={{ tooltip: { sx: {
                bgcolor: "#4191ff",
                "& .MuiTooltip-arrow": { color: "#4191ff" },
              } } }}
              arrow
            >
              <IconButton onClick={openTrashOptions} sx={sidebarActionsBtnSx} size="large" data-hf="sidebar-actions-btn">
                <MoreVertOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </span>
      </NavLink>
      <Menu
        anchorEl={anchorElTrashMenu}
        open={Boolean(anchorElTrashMenu)}
        onClose={handleCloseTrashOptions}
        slotProps={{
          list: { sx: { p: 0.5 } },
          paper: {
            sx: {
              overflow: 'visible',
              width: 'auto',
              minWidth: 'unset',
            },
          },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        keepMounted
      >
        <div>
          <List
            component="div"
            sx={{
              "& .MuiListItem-root.MuiListItem-button": { borderRadius: 0 },
              "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                color: "#368cff",
                background: "rgba(54, 140, 255, 0.05)",
                "&::before": { background: "#368cff" },
              },
            }}
            onClick={handleCloseTrashOptions}
          >
            <DeleteProperties
              sidebarMenu
              selected={trashedProperties.map(
                (property) => property._id,
              )}
            />
          </List>
        </div>
      </Menu>
    </Box>
  </ul>
)

export default TrashSection
